// extracted by mini-css-extract-plugin
export default {"section":"uoloO4","section_title":"IPB_WJ","sectionTitle":"IPB_WJ","section_text":"wrRHtD","sectionText":"wrRHtD","toggle":"nXQcg4"};